/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_TitleInputs */



/**
* | output |
* | --- |
* | "Align Right" |
*
* @param {Align_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_title = /** @type {((inputs?: Align_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner a Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtsbündig ausrichten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allinea a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выровнять справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाईं ओर संरेखित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhar à direita")
	return /** @type {LocalizedString} */ ("Align Right")
});